/*
 * lbrgt-quickbuy-stock.js
 *
 * Quick-Buy-Paritaet zur PDP fuer Groessen-Produkte (Schuhe), die aus den
 * Cart-/Karten-Empfehlungen per Quick-Buy in den Warenkorb gelegt werden.
 * Ziel (wie auf der PDP, siehe snippets/lbrgt-b2c-delivery-dates.liquid):
 *   1. Live-Bestandsabfrage der aktiven SKU ueber window.lbrgtStock
 *   2. properties[Lieferzeit] in die Warenkorb-Zeile schreiben
 *   3. properties[<Ausgewaehlte Groesse>] = "UK: <x>" wenn UK aktiv
 *   4. ATC (Button disabled + Text) an der Connector-4-Regel, nicht an
 *      Shopifys variant.available.
 *
 * WARUM ein eigenes, gescoptes Modul statt Wiederverwendung der PDP-Logik:
 * lbrgt-b2c-delivery-dates arbeitet dokumentweit (button[name="add"],
 * .product-info__add-to-cart, #variant_switcher_<id>, on:variant:change am
 * document). Im Drawer wuerde das in die PDP-Elemente schreiben (doppelte IDs,
 * erstes Formular gewinnt) und die frisch stabilisierte PDP-Anzeige verfaelschen.
 * Deshalb liest dieses Modul ausschliesslich innerhalb des <quick-add-drawer>
 * und schreibt nur in dessen Formular.
 *
 * Datenquelle: die JSON-Insel <script class="lbrgt-quickbuy-stock-data"> aus
 * dem quick-buy-template (sections/main-product.liquid) - sie reist mit dem
 * Produkt-Fetch mit und enthaelt Land, Uebersetzungen und je Variante die
 * Connector-Metafelder. Die Live-Werte (xde10/stores) kommen wie auf der PDP
 * frisch aus window.lbrgtStock; in_transit/wochen/retouren aus der Insel.
 *
 * Eingehaengt aus assets/quick-add.js (init nach renderProduct, onVariantChange
 * im on:variant:change-Handler des Drawers). Global geladen in layout/theme.liquid.
 */
(function () {
  if (window.lbrgtQuickbuyStock) return;

  // Kontext je Drawer (Metafelder, Land, Uebersetzungen, Request-Zaehler).
  var drawerCtx = new WeakMap();

  function num(v) { return (typeof v === 'number') ? v : (parseFloat(v) || 0); }

  function readIsland(drawer) {
    var el = drawer.querySelector('script.lbrgt-quickbuy-stock-data');
    if (!el) return null;
    var variants;
    try { variants = JSON.parse(el.textContent); } catch (e) { return null; }
    if (!variants) return null;
    var country = el.getAttribute('data-country') || '';
    return {
      variants: variants,
      isGermany: country === 'DE',
      t: {
        days: el.getAttribute('data-t-days') || 'Tage',
        weeks: el.getAttribute('data-t-weeks') || 'Wochen',
        deliveryTime: el.getAttribute('data-t-delivery-time') || 'Lieferzeit',
        checking: el.getAttribute('data-t-checking') || '...',
        selectedSize: el.getAttribute('data-t-selected-size') || 'Ausgewählte Größe',
        soldOut: el.getAttribute('data-t-sold-out') || 'Ausverkauft'
      },
      reqId: 0,
      lastDeliveryText: {}
    };
  }

  // Der Drawer wird fuer verschiedene Produkte wiederverwendet. Die ctx (Insel-
  // Metafelder des aktuellen Produkts) wird deshalb NICHT lazy gecacht, sondern
  // bei jedem neuen Produkt in init() frisch gesetzt. Hier nur lesen.
  function getCtx(drawer) { return drawerCtx.get(drawer); }

  function getForm(drawer) { return drawer.querySelector('.js-product-form'); }
  function getAddBtn(drawer) {
    var f = getForm(drawer);
    return f ? f.querySelector('button[name="add"]') : null;
  }

  // Dieselbe 4-Regel-Reihenfolge wie getDeliveryText in
  // lbrgt-b2c-delivery-dates.liquid und lbrgt-variant-verfuegbar.liquid.
  // liveData: {xde10, stores} aus window.lbrgtStock (Rueckfall: Snapshot).
  // meta:     Insel-Metafelder der Variante (in_transit/wochen/retouren).
  function getDeliveryText(liveData, meta, ctx) {
    var xde10 = num(liveData && liveData.xde10);
    var stores = num(liveData && liveData.stores);

    if (xde10 > 0) return '2-3 ' + ctx.t.days;                       // 1. Zentrallager
    if (ctx.isGermany && stores > 0) return '4-8 ' + ctx.t.days;     // 2. Filialen (nur DE)

    var inTransit = num(meta && meta.in_transit_b2c);                // 3. Zulauf
    if (inTransit > 0) {
      var wochen = num(meta && meta.lieferzeit_wochen);
      if (wochen > 0) return wochen + '-' + (wochen + 1) + ' ' + ctx.t.weeks;
      return null;
    }

    if (num(meta && meta.retourenbestand) > 0) return '1-2 ' + ctx.t.weeks; // 4. Retourenlager
    return null;                                                     // sonst: nicht verfuegbar
  }

  // ATC-Button im Drawer setzen (immer sichtbar; disabled + "Ausverkauft" wenn
  // nicht verfuegbar). Anders als die PDP versteckt der Drawer den Button nicht -
  // es gibt hier keine Backorder-/Restock-Anzeige, ein leerer Footer waere
  // schlechter als ein deutlich ausgegrauter Ausverkauft-Knopf.
  function updateAddButton(drawer, isAvailable, ctx) {
    var btn = getAddBtn(drawer);
    if (!btn) return;
    var atc = drawer.querySelector('.product-info__add-to-cart');
    if (atc) atc.removeAttribute('hidden');
    if (isAvailable) {
      btn.disabled = false;
      var addText = btn.getAttribute('data-add-to-cart-text');
      if (addText) btn.textContent = addText;
    } else {
      btn.disabled = true;
      btn.textContent = ctx.t.soldOut;
    }
  }

  // properties[Lieferzeit] am Drawer-Formular - identischer Property-Name wie PDP.
  function updateDeliveryProperty(drawer, text) {
    var form = getForm(drawer);
    if (!form) return;
    var input = form.querySelector('input[name="properties[Lieferzeit]"]');
    if (!text) { if (input) input.remove(); return; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Lieferzeit]';
      form.appendChild(input);
    }
    input.value = text;
  }

  // Sichtbare Lieferzeit-Anzeige im Drawer - Paritaet zu #lbrgt-delivery-result auf
  // der PDP (lbrgt-b2c-delivery-dates.liquid). Zeigt "Lieferzeit: <Text>", waehrend
  // der Live-Abfrage den "wird geprueft"-Text, und blendet aus, wenn nicht lieferbar.
  // Das Element steht statisch im quick-buy-template und ueberlebt Varianten-/
  // Farbwechsel; nur dieses Modul aktualisiert es.
  function getDeliveryEl(drawer) {
    return drawer.querySelector('[data-lbrgt-quickbuy-delivery]');
  }
  function setDeliveryText(drawer, str) {
    var el = getDeliveryEl(drawer);
    if (!el) return;
    if (str) { el.textContent = str; el.hidden = false; }
    else { el.textContent = ''; el.hidden = true; }
  }

  // properties[<Ausgewaehlte Groesse>] = "UK: <x>" - nur wenn UK aktiv. Quelle
  // fuer EU/UK ist window.SizeConversion (global, sessionStorage), nicht
  // .size-tab.active. Der UK-Wert steht server-gebacken am #variant_switcher_<id>
  // (data-uk-size) im Drawer-Markup. Property-Name identisch zur PDP, damit
  // PDP- und Quick-Buy-Zeilen desselben Artikels sauber zusammenfallen.
  function updateSizeProperty(drawer, variantId, ctx) {
    var form = getForm(drawer);
    if (!form) return;
    // Property-Name wie auf der PDP (lbrgt-b2c-delivery-dates.liquid) - identisch,
    // damit PDP- und Quick-Buy-Zeilen desselben Artikels/derselben Groesse
    // zusammenfallen. Kein CSS.escape: der Wert steht in doppelten Anfuehrungs-
    // zeichen, Leerzeichen/Umlaute/Klammern sind darin gueltig (so macht es die PDP).
    var name = 'properties[' + ctx.t.selectedSize + ']';
    var input = form.querySelector('input[name="' + name + '"]');
    var isUK = !!(window.SizeConversion && window.SizeConversion.getType && window.SizeConversion.getType() === 'uk');
    if (!isUK) { if (input) input.remove(); return; }

    // Auf den Drawer gescopt (getElementById waere dokumentweit -> auf einer PDP
    // das falsche, gleichnamige Element).
    var el = drawer.querySelector('[id="variant_switcher_' + variantId + '"]');
    if (!el) return;
    var uk = (el.getAttribute('data-uk-size') || '').trim();
    if (!uk) return;
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = 'UK: ' + uk;
  }

  // Groessen-Property bedingungslos entfernen (z.B. wenn nach einem
  // Combined-Listing-Wechsel die Variante unbekannt ist -> keine Alt-Property
  // mit der neuen variant-id in den Warenkorb schicken).
  function removeSizeProperty(drawer, ctx) {
    var form = getForm(drawer);
    if (!form || !ctx) return;
    var input = form.querySelector('input[name="properties[' + ctx.t.selectedSize + ']"]');
    if (input) input.remove();
  }

  function render(drawer, ctx, variantId, liveData) {
    var meta = ctx.variants[variantId] || {};
    var text = getDeliveryText(liveData, meta, ctx);
    ctx.lastDeliveryText[variantId] = text;
    updateAddButton(drawer, !!text, ctx);
    updateDeliveryProperty(drawer, text);
    setDeliveryText(drawer, text ? (ctx.t.deliveryTime + ': ' + text) : '');
    updateSizeProperty(drawer, variantId, ctx);
  }

  // Live-Abfrage der aktiven SKU, danach ATC + Properties spiegeln. Waehrend der
  // Abfrage wird der Button deaktiviert und auf "wird geprueft" gesetzt (wie PDP),
  // damit ein Klick nicht ohne Property/vor der Entscheidung durchgeht.
  // Liefert die ctx, die die gegebene Variante kennt. Bei COMBINED LISTINGS
  // wechselt der Drawer per Varianten-/Farbklick auf ein ANDERES Produkt;
  // variant-picker.js tauscht dann die mit data-dynamic-product-content markierte
  // JSON-Insel gegen die des neuen Produkts aus - der JS-ctx wird dabei aber NICHT
  // automatisch neu gelesen. Kennt die aktuelle ctx die Variante nicht, lesen wir
  // die (jetzt getauschte) Insel einmal frisch ein und setzen ctx neu.
  function ctxForVariant(drawer, variantId) {
    var ctx = getCtx(drawer);
    if (ctx && ctx.variants[variantId]) return ctx;
    var fresh = readIsland(drawer);
    if (fresh) { drawerCtx.set(drawer, fresh); return fresh; }
    return ctx || null;
  }

  function evaluate(drawer, variant) {
    if (!variant || !variant.id) return;
    var variantId = String(variant.id);
    var ctx = ctxForVariant(drawer, variantId);
    if (!ctx) return;

    var meta = ctx.variants[variantId];
    if (!meta) {
      // Variante auch nach dem Insel-Neueinlesen unbekannt: eine evtl. noch am
      // Formular haengende Property des vorher gezeigten Produkts AKTIV entfernen,
      // damit sie nicht mit der neuen variant-id in den Warenkorb geht. Danach
      // Theme-Default lassen (kein Groessen-Produkt o.ae.).
      updateDeliveryProperty(drawer, null);
      setDeliveryText(drawer, '');
      removeSizeProperty(drawer, ctx);
      return;
    }
    var sku = variant.sku || meta.sku;
    if (!sku) return;

    var btn = getAddBtn(drawer);
    if (btn) { btn.disabled = true; btn.textContent = ctx.t.checking; }
    setDeliveryText(drawer, ctx.t.checking);

    var reqId = (ctx.reqId += 1);

    if (!window.lbrgtStock || !window.lbrgtStock.get) {
      // Ohne Live-Client: Snapshot-Metafelder auswerten (kein "Ausverkauft" auf Verdacht).
      render(drawer, ctx, variantId, { xde10: meta.xde10, stores: meta.stores });
      return;
    }

    window.lbrgtStock.get(sku).then(function (data) {
      // Stale-Schutz zweifach: reqId gegen die GEFANGENE ctx (Wechsel innerhalb
      // desselben Produkts) UND Identitaet gegen die AKTUELLE ctx (Produktwechsel
      // im wiederverwendeten Drawer ersetzt ctx -> eine ueberholte Antwort des
      // Vorprodukts darf das jetzt sichtbare Produkt nicht mehr anfassen).
      if (getCtx(drawer) !== ctx || reqId !== ctx.reqId) return;
      render(drawer, ctx, variantId, data || {});
    }).catch(function () {
      if (getCtx(drawer) !== ctx || reqId !== ctx.reqId) return;
      // Wie PDP: bei echtem Fehler den Snapshot nutzen, nicht pauschal "Ausverkauft".
      render(drawer, ctx, variantId, { xde10: meta.xde10, stores: meta.stores });
    });
  }

  // ---- Einmalige, dokumentweite Listener (nur Drawer-Formulare betroffen) ----

  // Sicherheitsnetz: die Groessen-Property synchron beim Absenden setzen (der
  // ATC wird bei jedem Wechsel neu gerendert; ein sehr schneller Klick koennte
  // sonst ohne UK-Property durchgehen). Streng auf Drawer-Formulare gescopt.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('js-product-form')) return;
    var drawer = f.closest('quick-add-drawer');
    if (!drawer) return;
    var ctx = getCtx(drawer);
    if (!ctx) return;
    var idInput = f.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;
    updateSizeProperty(drawer, String(idInput.value), ctx);
  }, true);

  // EU/UK-Umschaltung: die Groessen-Property offener Drawer aktualisieren.
  // (Die dokumentweite PDP-Funktion deckt den Drawer nicht ab.)
  document.addEventListener('size-conversion:change', function () {
    document.querySelectorAll('quick-add-drawer').forEach(function (drawer) {
      var ctx = drawerCtx.get(drawer);
      if (!ctx) return;
      var f = getForm(drawer);
      var idInput = f && f.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;
      updateSizeProperty(drawer, String(idInput.value), ctx);
    });
  });

  window.lbrgtQuickbuyStock = {
    // Aufgerufen nach renderProduct (Drawer frisch befuellt). Wertet die
    // initial gewaehlte Variante aus (fuer Empfehlungskarten ohne Auto-Farbklick,
    // die kein on:variant:change ausloesen).
    init: function (drawer) {
      // Insel des GERADE gerenderten Produkts frisch lesen (Drawer wird
      // fuer mehrere Produkte wiederverwendet -> keine alte ctx behalten).
      var ctx = readIsland(drawer);
      if (!ctx) { drawerCtx.delete(drawer); return; } // kein Groessen-Produkt / keine Insel
      drawerCtx.set(drawer, ctx);
      var f = getForm(drawer);
      var idInput = f && f.querySelector('input[name="id"]');
      var vid = idInput && idInput.value;
      if (!vid) return;
      var meta = ctx.variants[String(vid)];
      if (!meta) return;
      evaluate(drawer, { id: vid, sku: meta.sku });
    },

    // Aufgerufen im on:variant:change-Handler des Drawers.
    onVariantChange: function (drawer, variant) {
      if (!variant) return;
      evaluate(drawer, variant);
    }
  };
})();
